/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [


    
    {
      
        id      : 'padron',
        title   : 'gre',
        subtitle: 'gre',
        type    : 'group', //collapsable
        icon    : 'heroicons_outline:document',
        children: [
            {
                id   : 'consultagre',
                title: 'consultagre ',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/consultagre'
            },

             {
                id   : 'pdf',
                title: 'pdf ',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/pdf'
            },

              {
                id   : 'reporte',
                title: 'reporte ',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/reporte'
            },

            

             {
                id   : 'consultagrelocal',
                title: 'consultagrelocal ',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/consultagrelocal'
            },

             {
                id   : 'auditoria',
                title: 'auditoria ',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/pdf-auditoria'
            },

             {
                id   : 'dashboard-guias',
                title: 'dashboard guias ',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/dashboard-guias'
            },

             {
                id   : 'usuarios-sunat',
                title: 'usuarios-sunat ',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/usuarios-sunat'
            },

            {
                id   : 'mtc',
                title: 'MTC',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/mtc'
            },


        

            
          
        ]
    },

    {
      
        id      : 'vehiculo',
        title   : 'vehiculo',
        subtitle: 'vehiculo',
        type    : 'group', //collapsable
        icon    : 'heroicons_outline:document',
        children: [
            {
                id   : 'consulta',
                title: 'consulta ',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/vehiculo/consulta'
            },

           

            
          
        ]
    },


     {

        id      : 'telegram',
        title   : 'telegram',
        subtitle: 'telegram',
        type    : 'group', //collapsable
        icon    : 'heroicons_outline:document',
        children: [
            {
                id   : 'consulta',
                title: 'consulta ',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/telegram/consulta'
            },




        ]
    },

    // 🆕 Módulo Debug: sólo visible para lucy.bustamante@rovsac.com
    {
        id      : 'debug',
        title   : 'Debug',
        subtitle: 'Simulador Telegram',
        type    : 'group',
        icon    : 'heroicons_outline:bug-ant',
        hidden  : (() => { try { return (localStorage.getItem('email') || '').toString().trim().toLowerCase() !== 'lucy.bustamante@rovsac.com'; } catch (e) { return true; } }) as any,
        children: [
            {
                id   : 'debug-home',
                title: 'Historial',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/debug'
            },
            {
                id   : 'debug-new',
                title: 'Nueva prueba',
                type : 'basic',
                icon : 'mat_solid:add',
                link : '/debug/new'
            }
        ]
    }



];


export const compactNavigation: FuseNavigationItem[] = [

     
    {
      
        id      : 'padron',
        title   : 'padron',
        subtitle: 'padron',
        type    : 'group', //collapsable
        icon    : 'heroicons_outline:document',
        children: [
            {
                id   : 'consulta',
                title: 'consulta',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/consulta'
            },

            
          
        ]
    },
  
    
   
];
export const futuristicNavigation: FuseNavigationItem[] = [

     
    {
      
        id      : 'padron',
        title   : 'padron',
        subtitle: 'padron',
        type    : 'group', //collapsable
        icon    : 'heroicons_outline:document',
        children: [
            {
                id   : 'consulta',
                title: 'consulta',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/consulta'
            },

            
          
        ]
    },
   
   
   
];
export const horizontalNavigation: FuseNavigationItem[] = [

     
    {
      
        id      : 'padron',
        title   : 'padron',
        subtitle: 'padron',
        type    : 'group', //collapsable
        icon    : 'heroicons_outline:document',
        children: [
            {
                id   : 'consulta',
                title: 'consulta',
                type : 'basic',
                icon : 'mat_solid:dashboard',
                link : '/padron/consulta'
            },

            
          
        ]
    },

    
  
    
];
